import { constructUrl } from '../pages/dataInputs/suppliers/constructUrl';

const TOKEN = localStorage.getItem('token');

const convertPdfToBase64 = async (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result as string);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const fetchPDFFile = async (locationId: string) => {
  const response = await fetch(
    constructUrl(`pdf-creator/business-continuity-plan/${locationId}`),
    {
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    },
  );

  if (!response.ok) {
    throw new Error('Failed to fetch PDF file');
  }

  const blob = await response.blob();
  const base64 = await convertPdfToBase64(blob);

  return base64;
};
